import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withTranslations from '../../translations';
import { Prompt } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import {
  addJob,
} from '../../actions/addJob';

import { rootUrl } from '../../constants/urls';

import SectionedForm from '../../components/SectionedForm/SectionedForm';

import { formSections } from './constants';

class AddJobView extends Component {
  state = {
    changedForms: [],
  }

  // Check if lastJobAdded (id) has changed. That means that a new job
  // is successfully added, and user can be redirected to /jobs
  componentDidUpdate(prevProps, prevState) {
    if (this.props.lastJobAdded !== prevProps.lastJobAdded) {
      this.props.history.push(rootUrl());
    }
  }

  onFormSubmit = data => {
    this.props.actions.addJob(data);
  }

  // This is used to determine should an alert be displayed when trying to
  // navigate off the page with unsaved answers in the form
  updateChangedSections = (formName, action) => {
    switch (action) {
      case 'add':
        return this.setState(prevState => ({ changedForms: [...prevState.changedForms, formName] }));
      case 'remove':
        return this.setState(prevState => ({ changedForms: prevState.changedForms.filter(changedForm => changedForm !== formName)}));
      default:
        return;
    }
  }

  render() {
    const {
      t,
      gt,
      isSubmitting,
    } = this.props;

    const translatedFormSections = formSections(t.formSections);

    return (
      <main>
        <Prompt
          when={this.state.changedForms.length > 0}
          message={gt.unsavedAnswers}
        />
        <SectionedForm
          formTranslations={t.formSections}
          formSections={translatedFormSections}
          updateChangedSections={this.updateChangedSections}
          onSubmit={this.onFormSubmit}
          isSubmitting={isSubmitting}
          formName='add-job'
          formType='addJob'
        />
      </main>
    );
  }
}

const mapStateToProps = state => ({
  lastJobAdded: state.addJob.lastJobAdded,
  isSubmitting: state.form.isSubmitting,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    addJob: bindActionCreators(addJob, dispatch),
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslations(withRouter(AddJobView), 'AddJob'));



// WEBPACK FOOTER //
// ./src/views/AddJob/AddJobView.js